<template src="../templates/normal_fcont_42.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import PrintButton from '../components/PrintButton'
import DesignPaperTiles from '../components/DesignPaperTiles'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'

import { Carousel,Slide } from 'uiv'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
export default {
  name: 'app',
  data() {
    return {
      articleId: '42',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
   LabelFunMessage,FuncSearchRecommendLink,Carousel,Slide,FuncSearchGalleryQR,
   PrintButton,DesignPaperTiles,ReleaseDateForArticle
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['42-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['42-2']}
    ]};
  }
};
</script>
<style />


